import { doPost, doGet } from 'services/common'

// returns a promise
export const submitVote = (articleId, voteType) => {

    const body = {
        articleId: articleId,
        vote: voteType,
    }

    return doPost('/article/vote', body);

}

export const start = (breakId, stepId) => {

    let payload = {
        breakId: breakId,
        stepId: stepId,
    }

    return doPost(`/article/start`, payload);

}

export const complete = (breakId, stepId) => {

    let payload = {
        breakId: breakId,
        stepId: stepId
    }

    return doPost(`/article/complete`, payload);

}

export const getVotes = (articleId) => {
    return doGet(`/article/getVotes/${articleId}`);
}

export const awardPoints = (breakId, stepId, nonce) => {

    let payload = {
        breakId: breakId,
        stepId: stepId,
        nonce: nonce
    }

    return doPost(`/article/awardPoints`, payload);

}